import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import useTickets from '../../../../../store/ReactQueries/tickets/useTicket';
import TicketFilters from '../../../Tickets/Components/Filter/TicketFilters';
import { darkModeBackgroud } from '../../../../../utils/constants';
import { useLanguageStore } from '../../../../../store/useLanguageStore';
import { useDarkModeStore } from '../../../../../store/useDarkModeStore';
import { FilterComponentProps } from '../../../../../models/DataSelectType';

export const FilterTicComponent: React.FC<FilterComponentProps> = ({ showFilters, page, pageSize, filterData, setPage, setFilterData }) => {
    const { language } = useLanguageStore();
    const { darkMode } = useDarkModeStore();
    const { refetch: refetchTickets } = useTickets(page, pageSize, filterData);

    const [resetTrigger, setResetTrigger] = useState<number>(0);

    const removeFilters = () => {
        setPage(1);
        setFilterData([]);
        setResetTrigger((prev) => prev + 1);
    }

    useEffect(() => {
        if (filterData?.length === 0) {
            refetchTickets();
        }
    }, [filterData, refetchTickets]);


    const handleKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
        if (event.key === 'Enter') refetchTickets();
    };

    return (
        <div
            className='d-flex flex-column gap-2 card pt-2 pb-2 ps-4 pe-4'
            style={{ minWidth: 280, background: darkMode ? darkModeBackgroud : 'white', borderRadius: 0, border: 'none' }}
        >
            <div className='d-flex flex-row align-items-center'>
                <span
                    className='fw-bold'
                    style={{ fontSize: 13, color: darkMode ? 'white' : 'black' }}
                >
                    {language['FILTERS']}
                </span>
                <button
                    title={language['ClearFilters']}
                    className='btn btn-sm btn-light ms-auto'
                    style={{ border: showFilters ? '1px solid #CFD7DF' : 'none' }}
                    onClick={() => removeFilters()}
                >
                    <FilterAltOffIcon sx={{ width: 16, height: 20 }} />
                </button>
            </div>
            {
                <TicketFilters
                    filterData={filterData}
                    resetTrigger={resetTrigger}
                    setFilterData={setFilterData}
                />
            }
            <div className='mt-2 mb-3'>
                <Button
                    autoFocus
                    tabIndex={0}
                    className='w-100'
                    variant="contained"
                    onKeyDown={handleKeyDown}
                    onClick={() => refetchTickets()}
                >
                    {language['Apply']}
                </Button>
            </div>
        </div>
    );
}
export default FilterTicComponent